import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { prefetchAuth } from './hooks/useAuth';
import './styles/tokens.css';
import './styles/base.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The forecast is a daily-grain model and the backing stack is cold-start
      // prone, so a 30s staleTime bought almost nothing and made every screen
      // re-navigation pay a fresh round trip. Five minutes keeps navigation
      // instant; mutations call invalidateQueries, which refetches regardless
      // of staleTime, and the Topbar refresh button forces a reload on demand.
      staleTime: 5 * 60_000,
      // Keep results around well past staleTime so navigating away and back
      // renders cached data immediately and revalidates behind it.
      gcTime: 30 * 60_000,
      retry: 1,
    },
  },
});

// Start the auth round trips before React mounts, so a Function cold start and
// any SQL resume overlap the initial render instead of following it.
prefetchAuth(queryClient);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
